export default __webpack_public_path__ + "static/media/Smartcut.140ceca0.svg";